var currentInfoWindow = null;
var marker = [];
var infoWindow = [];
var map;

function initializeMap() {
	var latlng = new google.maps.LatLng(36.350595, 139.826106);
	var markerData = [ // マーカーを立てる場所名・緯度・経度
		{
			name: '本店',
			address: '小山市神鳥谷1-11-32',
			lat: 36.30148,
			lng: 139.79031,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin1.png'
		},
		{
			name: 'おやま広域農機センター',
			address: '小山市大字小袋170-2',
			lat: 36.313764,
			lng: 139.754415,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin1.png'
		},
		{
			name: '西部青果物集出荷所',
			address: '小山市大字小袋201',
			lat: 36.314628,
			lng: 139.754482,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin1.png'
		},
		{
			name: '大谷支店',
			address: '小山市横倉新田7-33',
			lat: 36.272965,
			lng: 139.822936,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin2.png'
		},
		{
			name: '間々田支店',
			address: '小山市乙女3-7-36',
			lat: 36.261421,
			lng: 139.762963,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin2.png'
		},
		{
			name: '美田支店',
			address: '小山市小袋202-1',
			lat: 36.315276,
			lng: 139.754979,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin2.png'
		},
		{
			name: '桑絹支店',
			address: '小山市出井1083-3',
			lat: 36.336386,
			lng: 139.851328,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin2.png'
		},
		{
			name: '小山支店',
			address: '小山市神鳥谷1-11-32',
			lat: 36.301626,
			lng: 139.790539,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin2.png'
		},
		{
			name: '下野支店',
			address: '下野市笹原135-1',
			lat: 36.40264,
			lng: 139.85351,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin2.png'
		},
		{
			name: '野木支店',
			address: '野木町中谷523-1',
			lat: 36.223414,
			lng: 139.746331,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin2.png'
		},
		{
			name: '思川ホール',
			address: '小山市萩島134',
			lat: 36.31151,
			lng: 139.777059,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin3.png'
		},
		{
			name: 'おとめホール',
			address: '小山市南乙女2-1-6',
			lat: 36.255338,
			lng: 139.752339,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin3.png'
		},
		{
			name: '東部営農支援センター（のぞみ館東部）',
			address: '小山市大字東黒田313－2（東部集出荷所敷地内）',
			lat: 36.253596,
			lng: 139.789343,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: '西部営農支援センター（のぞみ館西部）',
			address: '小山市大字小袋201（西部集出荷所敷地内）',
			lat: 36.314628,
			lng: 139.754482,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: '北部営農支援センター（のぞみ館北部）',
			address: '下野市小金井5-22-2',
			lat: 36.375659,
			lng: 139.836267,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: 'のぞみ館野木',
			address: '下都賀郡野木町友沼4954-1',
			lat: 36.235212,
			lng: 139.727250,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: '桑東部出張所',
			address: '小山市大字出井1083-3',
			lat: 36.336333,
			lng: 139.851211,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: '石橋下古山購買所',
			address: '下野市石橋531-3',
			lat: 36.438754,
			lng: 139.86033,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: 'グリーンセンター',
			address: '小山市乙女3-7-36（間々田支店敷地内）',
			lat: 36.261441,
			lng: 139.763000,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: 'のぎ松原大橋直売所',
			address: '野木町大字友沼4954-1（のぞみ館野木敷地内）',
			lat: 36.235242,
			lng: 139.727298,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: '国分寺農産物直売所',
			address: '下野市小金井5-22-2（北部営農支援センター敷地内）',
			lat: 36.375689,
			lng: 139.836297,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: 'よらっせ桑',
			address: '小山市扶桑1-4-13',
			lat: 36.355273,
			lng: 139.817582,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: '石橋農産物直売所「四季彩」',
			address: '下野市石橋531－3（石橋支店敷地内）',
			lat: 36.438784,
			lng: 139.86063,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: '道の駅思川',
			address: '小山市下国府塚25-1',
			lat: 36.308223,
			lng: 139.760499,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: '道の駅しもつけ',
			address: '下野市薬師寺3720-1',
			lat: 36.397152,
			lng: 139.883792,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: 'ヨークベニマル小山ゆうえんち店直売所',
			address: '小山市喜沢1475-182（ヨークベニマル店舗内）',
			lat: 36.334016,
			lng: 139.809421,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: 'ヨークベニマル雨ヶ谷店直売所',
			address: '小山市雨ヶ谷町61（ヨークベニマル店舗内）',
			lat: 36.284087,
			lng: 139.812321,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: 'イオン小山店直売所',
			address: '小山市中久喜1467-1（イオン店舗内）',
			lat: 36.321371,
			lng: 139.840439,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: 'ベイシアスーパーマーケット小山店直売所',
			address: '小山市立木934-1（ベイシア店舗内）',
			lat: 36.328378,
			lng: 139.789039,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: 'TAIRAYA小金井店直売所',
			address: '下野市駅東2-7-4（TAIRAYA店舗内）',
			lat: 36.374580,
			lng: 139.845380,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
        {
			name: '美田支店 2階',
			address: '小山市小袋202-1',
			lat: 36.315276,
			lng: 139.754979,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin1.png'
		},

	];

	var myOptions = {
		zoom: 11,
		center: latlng,
		mapTypeId: google.maps.MapTypeId.ROADMAP, //
		panControl: true, //1.左上の丸いの表示
		streetViewControl: true, //2.左の黄色い人形(pegman=ペグマン)表示
		zoomControl: true, //3.左の上下スライダー表示
		mapTypeControl: true, //4.右上の「地図/航空写真」表示
		scaleControl: false, //5.右下の定規の表示
		overviewMapControl: false, //6.右下の概観マップの表示
		//disableDefaultUI: true  //全コントローラを非表示
		scrollwheel: false
	};

	map = new google.maps.Map(document.getElementById('map_canvas'), myOptions);

	// マーカー毎の処理
	for (var i = 0; i < markerData.length; i++) {
		const markerLatLng = new google.maps.LatLng({lat: markerData[i]['lat'], lng: markerData[i]['lng']}); // 緯度経度のデータ作成
		marker[i] = new google.maps.Marker({ // マーカーの追加
			position: markerLatLng, // マーカーを立てる位置を指定
			map: map // マーカーを立てる地図を指定
		});

		infoWindow[i] = new google.maps.InfoWindow({ // 吹き出しの追加
			content: '<div class="map-info"><h5>' + markerData[i]['name'] + '</h5><p>' + markerData[i]['address'] + '</p></div>' // 吹き出しに表示する内容
		});

		markerEvent(i); // マーカーにクリックイベントを追加
		marker[i].setOptions({
			icon: {
				url: markerData[i]['icon']// マーカーの画像を変更
			}
		});
	}

	$("a.map-jump").each(function(){
		jQuery(this).bind("click", function(){
			if (currentInfoWindow) {
				currentInfoWindow.close();
			}
			var infoWindowNum = $(this).attr('mapnum');
			infoWindow[infoWindowNum].open(map, marker[infoWindowNum]);
			currentInfoWindow = infoWindow[infoWindowNum];
		});
	});
}
function markerEvent(i) {
	marker[i].addListener('click', function() { // マーカーをクリックしたとき

		if (currentInfoWindow) {
			currentInfoWindow.close();
		}

		infoWindow[i].open(map, marker[i]);
		currentInfoWindow = infoWindow[i];
	});
}
// google.maps.event.addDomListener(window , 'load' , initializeMap());
